// The hub's pages as they stand in E12-S1-T1: each its heading inside the frame and the empty state
// its own task replaces — /learn and the title page (E12-S2-T1, T2), /library (E12-S2-T3), /practice
// (E12-S4), /record (E12-S5), /companion (E12-S3-T3), /admin (E12-S6). Every word is the catalogue's.
import { t } from "../i18n/t.js";
import { EmptyState, Page } from "./page.js";

export function LearnPage() {
  return (
    <Page title={t("page.learn.title")}>
      <EmptyState icon="play" title={t("page.learn.empty")} line={t("page.learn.emptyLine")} />
    </Page>
  );
}

export function TitlePage(_props: { id: string }) {
  return (
    <Page title={t("page.title.title")}>
      <EmptyState icon="play" title={t("page.title.empty")} line={t("page.title.emptyLine")} />
    </Page>
  );
}

export function LibraryPage() {
  return (
    <Page title={t("page.library.title")}>
      <EmptyState icon="play" title={t("page.library.empty")} line={t("page.library.emptyLine")} />
    </Page>
  );
}

export function PracticePage() {
  return (
    <Page title={t("page.practice.title")}>
      <EmptyState
        icon="container"
        title={t("page.practice.empty")}
        line={t("page.practice.emptyLine")}
      />
    </Page>
  );
}

export function ScenarioPage(_props: { scenario: string }) {
  return (
    <Page title={t("page.scenario.title")}>
      <EmptyState
        icon="container"
        title={t("page.scenario.empty")}
        line={t("page.scenario.emptyLine")}
      />
    </Page>
  );
}

export function RecordPage() {
  return (
    <Page title={t("page.record.title")}>
      <EmptyState icon="check" title={t("page.record.empty")} line={t("page.record.emptyLine")} />
    </Page>
  );
}

export function WalkthroughRecordPage(_props: { walkthroughId: string }) {
  return (
    <Page title={t("page.walkthrough.title")}>
      <EmptyState
        icon="check"
        title={t("page.walkthrough.empty")}
        line={t("page.walkthrough.emptyLine")}
      />
    </Page>
  );
}

export function CompanionPage() {
  return (
    <Page title={t("page.companion.title")}>
      <EmptyState
        icon="companion"
        title={t("page.companion.empty")}
        line={t("page.companion.emptyLine")}
      />
    </Page>
  );
}
